import { ACCOUNT_LIMITED_POLICY_MESSAGE } from '../../../data/messages';
export const MAX_TOOLTIP_POSITION = 450;
export const NONE = 'None';

export const NO_RM_FOUND = 'No raw materials found';

export const LIMITED_ACC_MESSAGES = {
    TOXIN_GROUPS:
        ACCOUNT_LIMITED_POLICY_MESSAGE,
}

export const REPORT_GENERATION_MESSAGE = {
    MULTIPLE: 'Reports are generating. They will be available in My Reports shortly.',
    SINGLE: 'Report is generating. It will be available in My Reports shortly.',
}

export const DEFAULT_RM_TABLE_LAYOUT = {
    functions: true,
    inci: true,
    manufacturer: true,
    price: true,
    origin_country: true,
    manufacture_countries: true,
    product_manufacturers: true,
    created: false,
    modified: false,
    reference_number: false,
    status: false,
    supplier: false,
    tags: false,
    replacement_group: false,
    trade_name: true,
    frequency_of_use: true,
}

export const RM_COLUMN_SWITCHER_NAMES_OLD = {
    trade_name: 'Trade Name',
    reference_number: "Reference #",
    status: 'Status',
    manufacturer: 'Manufacturer',
    supplier: 'Supplier',
    functions: 'Functions',
    inci: 'INCI',
    replacement_group: 'Replacement Groups',
    tags: 'Tags',
    origin_country: 'Country of Origin',
    manufacture_countries: 'Country of Manufacture',
    price: 'Price',
    product_manufacturers: 'Product Manufacturers',
    modified: 'Last Updated (GMT)',
    created: 'Date Created (GMT)',
}
export const RM_COLUMN_SWITCHER_NAMES = {
    trade_name: 'Trade Name',
    reference_number: "Reference #",
    status: 'Status',
    manufacturer: 'Manufacturer',
    supplier: 'Supplier',
    functions: 'Functions',
    frequency_of_use: 'Frequency',
    inci: 'INCI',
    replacement_group: 'Replacement Groups',
    tags: 'Tags',
    origin_country: 'Country of Origin',
    manufacture_countries: 'Country of Manufacture',
    price: 'Price',
    product_manufacturers: 'Product Manufacturer',
    modified: 'Last Updated (GMT)',
    created: 'Date Created (GMT)',
}

export const FILTERS_TYPES = {
    STATUS: 'Status',
    MANUFACTURERS: 'Manufacturers',
    SUPPLIER: 'Suppliers',
    FUNCTIONS: 'Functions',
    APPLICATIONS: 'Applications',
    CERTIFICATIONS: 'Certifications',
    TAGS: 'Tags',
    PRICE_KG: 'PriceKg',
    LAST_UPDATED: 'LastUpdated',
    DATE_CREATED: 'Created',
    BIODEGRADABILITY: 'Biodegradability',
    ISO_16128: 'ISO16128',
    DOCUMENTS: 'Documents',
    COMPLIANCE: 'Compliance',
    REPLACEMENT_GROUP: 'ReplacementGroup',
}

export const REGULATION_STATUSES = {
    ACTIVE: 'Active',
    DRAFT: 'Draft',
}

export const FILTERS_TYPES_MULTI_DIAPASONS = {
    BIODEGRADABILITY: 'Biodegradability',
    NATURAL_CONTENT: 'NaturalContent',
    NATURAL_ORIGIN: 'NaturalOrigin',
    ORGANIC_CONTENT: 'OrganicContent',
    ORGANIC_ORIGIN: 'OrganicOrigin',
}

export const FILTERS_MAIN_TYPES = {
    MANUFACTURERS: FILTERS_TYPES.MANUFACTURERS,
    FUNCTIONS: FILTERS_TYPES.FUNCTIONS,
    COMPLIANCE: FILTERS_TYPES.COMPLIANCE,
}

export const FILTERS_MAIN_TYPES_OLD = {
    MANUFACTURERS: FILTERS_TYPES.MANUFACTURERS,
    FUNCTIONS: FILTERS_TYPES.FUNCTIONS,
    APPLICATIONS: FILTERS_TYPES.APPLICATIONS,
    CERTIFICATIONS: FILTERS_TYPES.CERTIFICATIONS,
    COMPLIANCE: FILTERS_TYPES.COMPLIANCE,
    STATUS: FILTERS_TYPES.STATUS,
}

export const FILTERS_GRADATION = {
    10: 10,
    20: 20,
    50: 50,
    90: 90,
    100: 100,
    WEEK: 'week',
    MONTH: 'month',
    HALF_YEAR: 'half_year',
    MORE: 'more',
    LESS: 'less',
    RANGE: 'range',
}

export const RANGES_NAMES = {
    BIODEGRADABILITY: 'Biodegradability',
    NATURAL_CONTENT: 'Natural Content',
    NATURAL_ORIGIN: 'Natural Origin',
    ORGANIC_CONTENT: 'Organic Content',
    ORGANIC_ORIGIN: 'Organic Origin',
}

export const FILTERS_MEASURE = {
    PRICE_KG: '$',
    NATURAL_CONTENT: '%',
    BIODEGRADABILITY: '%',
    ISO_16128: '%',
}

export const FILTERS_TITLES = {
    [FILTERS_TYPES.MANUFACTURERS]: 'Manufacturer',
    [FILTERS_TYPES.FUNCTIONS]: 'Functions',
    [FILTERS_TYPES.COMPLIANCE]: 'Compliance',
    [FILTERS_TYPES.SUPPLIER]: 'Supplier',
    [FILTERS_TYPES.APPLICATIONS]: 'Applications',
    [FILTERS_TYPES.CERTIFICATIONS]: 'Certifications',
    [FILTERS_TYPES.TAGS]: 'Tags',
    [FILTERS_TYPES.DOCUMENTS]: 'Documents',
    [FILTERS_TYPES.PRICE_KG]: 'Price per kg',
    [FILTERS_TYPES.LAST_UPDATED]: 'Last Updated',
    [FILTERS_TYPES.DATE_CREATED]: 'Date Created',
    [FILTERS_TYPES.BIODEGRADABILITY]: 'Biodegradability',
    [FILTERS_TYPES.ISO_16128]: 'ISO16128',
    [FILTERS_TYPES.REPLACEMENT_GROUP]: 'Replacement Group',
    [FILTERS_TYPES.STATUS]: 'Status',
    SEE_MORE: 'See More',
    SEE_LESS: 'See Less',
    UP_TO: 'up to',
    MAIN: {
        ALL_FILTERS: 'All Filters',
        SELECTED_FILTERS: 'Selected Filters',
    },
    BUTTONS: {
        SCREEN: 'Screen',
        APPLY: 'Apply',
        APPLY_SELECTED: 'Apply Selected',
        CLEAR: 'Clear',
        CLEAR_ALL: 'Clear All',
        MORE_FILTERS: 'More Filters',
        [FILTERS_TYPES.LAST_UPDATED]: {
            [FILTERS_GRADATION.WEEK]: 'Last week',
            [FILTERS_GRADATION.MONTH]: 'Last month',
            [FILTERS_GRADATION.HALF_YEAR]: 'Last 6 months',
            [FILTERS_GRADATION.RANGE]: 'Range',
        },
        [FILTERS_TYPES.DATE_CREATED]: {
            [FILTERS_GRADATION.WEEK]: 'Last week',
            [FILTERS_GRADATION.MONTH]: 'Last month',
            [FILTERS_GRADATION.HALF_YEAR]: 'Last 6 months',
            [FILTERS_GRADATION.RANGE]: 'Range',
        },
        [FILTERS_TYPES.PRICE_KG]: 'Less than',
        [FILTERS_GRADATION.RANGE]: 'Range',
    }
}

export const TOOLTIPS_TITLES = {
    publishedTnl: 'Trade Name Library - ',
    exportSelected: 'Export current view of selected raw materials to XLS',
    exportAll: 'Export current view of My Raw Materials to XLS',
};

export const DOCUMENT_FILTER_OPTIONS = [
    { value: 'documents_include_all', label: 'Include all of the selected' },
    { value: 'documents_include_any', label: 'Include any of the selected' },
    { value: 'documents_exclude_all', label: 'Exclude all of the selected' },
    { value: 'documents_exclude_any', label: 'Exclude any of the selected' }
];
